import React from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";

import InputText from "../form-inputs/input-text.component";

interface DraftSearchBoxProps {
	value: string;
	onChange: (value: string) => void;
	placeholder: string;
	resultCount: number;
	totalCount: number;
}

export default function DraftSearchBox({
	value,
	onChange,
	placeholder,
	resultCount,
	totalCount,
}: DraftSearchBoxProps) {
	return (
		<div className="draft-search-row">
			<InputText
				icon={<FaMagnifyingGlass />}
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				hasClearField={value !== ""}
				onClearField={() => onChange("")}
			/>
			{value.trim() !== "" && (
				<div className="draft-search-count">
					{resultCount} of {totalCount}
				</div>
			)}
		</div>
	);
}
